<div class="row g-4">
    @if (access.orderPlanningMix) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Order Planning Mix">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadOrderPlanningMix"
                    [palette]="palettes.orderPlanningMix"
                    centerText="Loose & Layer Mix"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.postProductionMdt) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Post-Production MDT">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadPostProductionMdt"
                    [palette]="palettes.postProductionMdt"
                    [centerText]="postProductionCenterText"
                    formatMode="decimal"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.preProductionOrders) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Pre-Production Orders">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadPreProductionOrders"
                    [palette]="palettes.preProductionOrders"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
        <div class="col-12 col-lg-6">
            <app-dashboard-tiles [items]="preProductionTiles"></app-dashboard-tiles>
        </div>
    }
</div>
